export default "__VITE_ASSET__B8M6fIa___"